// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionbar {
  display: block;
  padding: 10px 20px;
  color: #444444;
  border: none;
  margin-bottom: 15px;
  background-color: #e6e0cd;
  height: auto;
}
.actionbar .ab-content {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.actionbar .ab-content .ab-title {
  display: inline-flex;
  flex-basis: auto;
  min-width: 120px;
}
.actionbar .ab-content .ab-title p {
  margin: 0;
  font-weight: 600;
  font-size: 20px;
  line-height: 50px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/action-bar/action-bar.component.less"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AADJ;AANA;EAUQ,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AADR;AAbA;EAiBY,oBAAA;EACA,gBAAA;EACA,gBAAA;AADZ;AAlBA;EAsBgB,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADhB","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.actionbar{\n    display: block;\n    padding: 10px 20px;\n    color: @secondary-90;\n    border: none;\n    margin-bottom: 15px;\n    background-color: @neutral-background-base;\n    height: auto;\n    \n    .ab-content{\n        display: inline-flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n        \n        .ab-title{\n            display: inline-flex;\n            flex-basis: auto;\n            min-width: 120px;\n            \n            p{\n                margin: 0;\n                font-weight: 600;\n                font-size: 20px;\n                line-height: 50px;\n            }\n        }       \n                \n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
